import Vue from "vue";
import VueRouter from "vue-router";
import Pending from "@/views/Pending.vue";
import History from "@/views/History.vue";
import ToCompute from "@/views/ToCompute.vue";
import Computed from "@/views/Computed.vue";
import NotComputed from "@/views/NotComputed.vue";
import Notifications from "@/views/Notifications.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/nouvelles-demandes",
  },
  {
    path: "/nouvelles-demandes",
    name: "Nouvelles demandes",
    component: Pending,
  },
  {
    path: "/a-calculer",
    name: "Demandes à calculer",
    component: ToCompute,
  },
  {
    path: "/calculees",
    name: "Demandes calculées",
    component: Computed,
  },
  {
    path: "/non-calculees",
    name: "Demandes non calculées",
    component: NotComputed,
  },
  {
    path: "/historique",
    name: "Historique",
    component: History,
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
